/*!
 * ATS Partner Template - Version: 0.2.13 
 * Indeed - Copyright (c) 2020
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are 
 * licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
$(document).ready(function() {
    // Tabs
    $('.tab-navigation--ats-partner .nav-tabs a, a.ats-cta-tab').on('click', function(e) {
        e.preventDefault();
        var headerOne = $('#tab-header-1'),
              headerTwo = $('#tab-header-2'),
              heroImage = $('.hero-image');

        // Change header content
        $('.ats-tab-header, .hero-image').removeClass('active in hero-image-tab1 hero-image-tab2');

        if($(this).attr('href') === '#tab1') {
            heroImage.addClass('hero-image-tab1');
            headerOne.addClass('active in');
        } else {
            heroImage.addClass('hero-image-tab2');
            headerTwo.addClass('active in');
        }

        // Change body content
        $('.nav-tabs li').removeClass('active');
        $(this).tab('show');

        // Show selected tab when clicking from cta
        if($(this).attr('href') === '#tab1') {
            $('.nav-tabs li:eq(0)').addClass('active');
        } else {
            $('.nav-tabs li:eq(1)').addClass('active');
        }
        window.scrollTo(0, 0);
    });

    // Dropdown button
    var dropdownBtn = $('.ats-btn-dropdown');

    dropdownBtn.on('click', function() {
        $('.ats-card-dropdown-btn').toggleClass('is-open');
    });

    // Close dropdown when clicking outside button
    $(document).on('mouseup', function(e){
        if(!$(e.target).hasClass('ats-btn ats-btn-dropdown')) {
            $('.ats-card-dropdown-btn').removeClass('is-open');
        }
    });
// Moved Owl Carousel to Components.

});

